'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name slickSliderHelper
    * @description Manage slick sliders through this helper
    **/

    // Initializes a slick slider
    // Supports optional disabling and reenabling of the slider when transitioning back and forth between desktop and mobile
    // Use settings "unslick-above" and "unslick-below" like:
    //
    //    responsive: [
    //        {
    //            breakpoint: 991,
    //            settings: "unslick-above"
    //        },
    //        {
    //            breakpoint: 768,
    //            settings: {
    //                slidesToShow: 1,
    //            }
    //        }
    //    ]
    var initialize = function(containerSelector, options) {
        if ($(containerSelector).length === 0) {
            return;
        }

        // supports a single upper and lower breakpoint for unslicking
        const unslickBelowBreakpoint = _.find(options.responsive, function (obj) {
            return obj.settings === 'unslick-below' && Number.isInteger(obj.breakpoint);
        });

        const unslickAboveBreakpoint = _.find(options.responsive, function (obj) {
            return obj.settings === 'unslick-above' && Number.isInteger(obj.breakpoint);
        });

        const hasUpperBreakpoint = unslickAboveBreakpoint && Number.isInteger(unslickAboveBreakpoint.breakpoint);
        const hasLowerBreakpoint = unslickBelowBreakpoint && Number.isInteger(unslickBelowBreakpoint.breakpoint);

        const windowWidth = $(window).width();
        const violatesUpperBound = hasUpperBreakpoint && windowWidth > unslickAboveBreakpoint.breakpoint;
        const violatesLowBound = hasLowerBreakpoint && windowWidth <= unslickBelowBreakpoint.breakpoint;
        if (!violatesUpperBound && !violatesLowBound) {
            $(containerSelector).not('.slick-initialized').slick(options);
        }

        if (hasUpperBreakpoint || hasLowerBreakpoint) {
            $(window).on('resize', function () {
                const windowWidth = $(window).width();
                $(containerSelector).each(function () {
                    let $this = $(this);
                    const isInitialized = $this.hasClass('slick-initialized');
                    const violatesUpperBound = hasUpperBreakpoint && windowWidth > unslickAboveBreakpoint.breakpoint;
                    const violatesLowBound = hasLowerBreakpoint && windowWidth <= unslickBelowBreakpoint.breakpoint;
                    if (isInitialized && (violatesUpperBound || violatesLowBound)) {
                        $this.slick('unslick');
                    }
                    else if (!isInitialized && !violatesUpperBound && !violatesLowBound) {
                        $this.slick(options);
                    }
                })
            });
        }
    }

    // Return an object exposing the public items
    return {
        initialize: initialize
    };
}())